/**
 * RateLimiter — token bucket per supplier.
 */
export class RateLimiter {
  private readonly buckets = new Map<string, { tokens: number; updatedAt: number }>()
  private limitPerMinute: number

  constructor(limitPerMinute = 60) {
    this.limitPerMinute = limitPerMinute
  }

  setLimit(limitPerMinute: number): void {
    this.limitPerMinute = Math.max(1, limitPerMinute)
  }

  async acquire(supplierId: string): Promise<void> {
    const now = Date.now()
    const bucket = this.buckets.get(supplierId) ?? {
      tokens: this.limitPerMinute,
      updatedAt: now,
    }

    const elapsedMinutes = (now - bucket.updatedAt) / 60_000
    bucket.tokens = Math.min(
      this.limitPerMinute,
      bucket.tokens + elapsedMinutes * this.limitPerMinute,
    )
    bucket.updatedAt = now

    if (bucket.tokens < 1) {
      this.buckets.set(supplierId, bucket)
      throw new Error(`Rate limit excedido para ${supplierId}`)
    }

    bucket.tokens -= 1
    this.buckets.set(supplierId, bucket)
  }

  remaining(supplierId: string): number {
    return Math.floor(this.buckets.get(supplierId)?.tokens ?? this.limitPerMinute)
  }

  reset(supplierId?: string): void {
    if (supplierId) this.buckets.delete(supplierId)
    else this.buckets.clear()
  }
}

export const rateLimiter = new RateLimiter()
